import React from 'react';
import {Dialog, DialogActions, DialogContent, Fab, CircularProgress} from '@material-ui/core'




export default class LoadingDialog extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
      
         }
    }

     componentDidMount(){
          
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="insertDialog"
                style={{padding:10}}
                disableEscapeKeyDown
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                        <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-anuleaza-button">
                            <i className='material-icons textPrimary iconFontSize'>close</i>
                        </Fab>
                 </DialogActions>
              
              <DialogContent style={{textAlign:'center'}}>
                    <CircularProgress  style={{width:60, height:60, color:'#20de20'}} />
                 <h2 style={{padding:10}} className='pm-title-big'>{this.props.title}</h2>
              </DialogContent>
             

                   
                 </Dialog>
         </div>
        );
       }
}